<template>
  <div class="home-view">
    <HeroSection />
    <WelcomeSection />
    <BuildersSection />
    <TestimonialsSection />
  </div>
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue';
import WelcomeSection from '@/components/WelcomeSection.vue';
import BuildersSection from '@/components/BuildersSection.vue';

import TestimonialsSection from '@/components/TestimonialsSection.vue';
</script>

<style scoped>
.home-view {
  overflow-x: hidden;
}
</style>
